/**
 * Ссылки старых страниц — в CRM, а не в Amo и не в наши дашборды (владелец 02.10.2026: «фокусные сделки без
 * ссылок на Amo — ссылками на CRM; выезды, производство — тоже связать с CRM, а не с нашими дашбордами»).
 *
 * Старые страницы (мессенджер, «Контроль сделок», «Фокусные», выезды, производство) живут на поддоменах и знают
 * про сделку только номер Amo и телефон. CRM — на основном домене под /crm/; её адрес /crm/card сам находит
 * нашу сделку по номеру Amo (нет — по телефону) и переходит на постоянную ссылку /crm/lead/<id>.
 */
const SUB = /^(sales|production|finance|warehouse|messenger|marketing|commercial|dashboard)\./;

/** https://<основной домен>/crm */
export function crmBase(): string {
  // CRM компании brixcrm живёт в корне её поддомена (04.10.2026): krepkiyjar.brixcrm.ru/lead/…
  if (/\.brixcrm\.ru$/.test(window.location.hostname)) return window.location.origin;
  return `${window.location.protocol}//${window.location.hostname.replace(SUB, "")}/crm`;
}

/** Номер сделки Amo из ссылки вида …amocrm.ru/leads/detail/123. */
export function amoIdOf(url?: string | null): number | null {
  const m = /\/leads\/detail\/(\d+)/.exec(url || "");
  return m ? Number(m[1]) : null;
}

/** Карточка сделки в CRM по номеру Amo (или ссылке на Amo) и телефону; нечем найти — null. */
export function crmDealUrl(amo?: number | string | null, phone?: string | null, amoUrl?: string | null): string | null {
  // «Контроль сделок» и «Фокусные» (02.10.2026): у сделок, заведённых уже в CRM, номера Amo нет —
  // их ключ «минус номер CRM».
  if (Number(amo) < 0) return `${crmBase()}/lead/${-Number(amo)}`;
  const id = Number(amo) || amoIdOf(amoUrl);
  const q = new URLSearchParams();
  if (id) q.set("amo", String(id));
  if (phone && phone.trim()) q.set("phone", phone.trim());
  const qs = q.toString();
  return qs ? `${crmBase()}/card?${qs}` : null;
}

/** Единая карточка в CRM с вкладкой «Производство» — по номеру проекта производства. */
export function crmProductionUrl(id?: number | null): string | null {
  return id ? `${crmBase()}/card?production=${id}` : null;
}
